import React , { useEffect, useState } from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { pushtracking } from '../../../service/trackingService';
import { useLocation } from '@reach/router';
import { navigate } from "gatsby";

import './css/termsofuse.css';
const Gioithieu=()=> {
    const location = useLocation();
    const [meta, setMeta] = useState([]);
    useEffect(() => {
      try{
        pushtracking(window.localStorage.getItem('sessionId')??null,
        window.localStorage.getItem('_id')??null,
        window.localStorage.getItem('phone')??null ,
        location.pathname, "Giới thiệu về Bibo Mart", 0,0,'index','inWeb',[],'Website PC').then((response)=>{
            // console.log('send tracking');
        });
      }catch(e){console.log(e)}
      
    },[])
  return (
   <Layout>
        <div className="container">
        <div className="header row d-flex pdy-10 mgx-0 mgt-10">
            <div className="col-1 in-f" onClick={() => window.Location.back()}>
                <i className="fa-solid fa fa-chevron-left"></i>
            </div>
            <div className="col-10 flex-center">
                <span className="text_14 font_700">Chính sách ưu đãi đặc quyền</span>
            </div>
            <div className="col-1"></div>
        </div>

        
          {/* <h1 className='d-none'>Chính sách ưu đãi đặc quyền</h1> */}
        <div className='container page-builder-ltr p-0'>
          <div className='container-page-customerpolicy p-0'>
            <div className="main-landing-store p-0">
                <div className="banner_top">
                {/* <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231128-mo-vi-doi-qua-1170-1300.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing2.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing3.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing4.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing5.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing6.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing7.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing8.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing9.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing10.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing11.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing12.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing13.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing14.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing15.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing16.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing17.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing18.jpg" alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing19.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing20.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing21.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing22.jpg"  alt=""/>
                <img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231114-dem-xu-doi-qua-landing23.jpg"  alt=""/>
                <a href="http://onelink.to/tf6fk5" target="_blank"><img lazy="" src="https://media.bibomart.com.vn/resize.1170x-/media/wysiwyg/bibomart_homepage/20231117-mo-vi-doi-qua-landing100.jpg" alt=""/></a> */}
                <img className='w-100' lazy="" src="https://media.bibomart.net/image/2024-07-08_44a0b45e-9dc9-4d72-a2c4-c5604123e138.jpg/origin" alt=""/>
                <img className='w-100'  lazy="" src="https://media.bibomart.net/image/2024-07-08_31407305-5993-4bff-bc8f-2b936dfd783b.jpg/origin" alt=""/>
                <img className='w-100' lazy="" src="https://media.bibomart.net/image/2024-07-08_26709d5a-8138-4ee5-b620-ba6cb0efe8c5.jpg/origin" alt=""/>
                <img className='w-100' lazy="" src="https://media.bibomart.net/image/2024-07-08_9a07c96c-4c3a-43df-ab4f-1a4eb9cb3fec.jpg/origin" alt=""/>
                <img className='w-100' lazy="" src="https://media.bibomart.net/image/2024-07-08_62d59b03-fc1e-4ed8-9abd-ccb285167b42.jpg/origin" alt=""/>
                </div>
            </div>
          </div>
        </div>

        <div className="footer text_13 font_500 mt-3">
            <div className="row">
                <div className="col-12">
                    <div className="card card-border flex-center-col">
                        <span className="">Mọi thắc mắc, vui lòng liên hệ:</span>
                        <span className="font_700 color_red">P. Chăm sóc Khách hàng</span>
                        <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                        <span className="">Hotline: 1800 6886 (Miễn phí)</span>
                        <span className="">Email: cskh@bibomart.com.vn</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
   </Layout>
  )
}
export default Gioithieu;